export enum CampaignAudienceEvaluationFrequency {
    CAMPAIGN_ENTRY = 'before_campaign_entry',
    STEP_ENTRY = 'before_step_entry',
}
